import styled, { css } from 'styled-components';
import { LAYOUT_1_2, LAYOUT_2_0 } from '../constants';

/**
 * @component
 */
export default styled.img`
  max-width: 80px;
  max-height: 70px;
  
  ${({ ignoreTight }) => !ignoreTight && css`
    @media ${({ theme }) => theme.breakpoints.tight} {
      ${({ layout }) => ![LAYOUT_1_2, LAYOUT_2_0].includes(layout) && css`
        max-width: 60px;
        max-height: 53px;
      `};
    }
  `};
`;
